import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { DialogRoute } from 'src/components/shared/routes/DialogRoute';
import { FollowFailedDialog } from './FollowFailedDialog';
import { FollowSucceededDialog } from './FollowSucceededDialog';

export const ResortFollowRouting: React.FC = () => {
  const routeMatch = useRouteMatch();
  if (!routeMatch) {
    return null;
  }

  const basePath = routeMatch.path;

  return (
    <>
      <DialogRoute path={`${basePath}/follow-succeeded`}>
        <FollowSucceededDialog action={'follow'} />
      </DialogRoute>
      <DialogRoute path={`${basePath}/follow-failed`}>
        <FollowFailedDialog />
      </DialogRoute>
      <DialogRoute path={`${basePath}/unfollow-succeeded`}>
        <FollowSucceededDialog action={'unfollow'} />
      </DialogRoute>
      <DialogRoute path={`${basePath}/unfollow-failed`}>
        <FollowFailedDialog />
      </DialogRoute>
    </>
  );
};
